import React from 'react';
import { Navigate } from 'react-router-dom';
import useHankoAuth from '../../hooks/useHankoAuth';
import ViewLoading from '../common/ViewLoading';
import { useSubscription } from './useSubscription';

const PaidFeatureRoute = ({ feature, children }) => {
    const { user } = useHankoAuth();
    const { plan, loading, error, hasFeature } = useSubscription();

    if (user?.email?.endsWith('@tendera.bid')) return children;
    if (loading) return <ViewLoading />;

    // Match the backend: customer access needs a non-Free plan and the effective
    // feature entitlement, including organization overrides. Missing plans fail closed.
    // `feature` may be a list: any one of them grants access (e.g. Eye implies Analytics).
    const planType = plan?.plan?.planType || 'FREE';
    const entitled = [].concat(feature).some(hasFeature);
    if (error || planType.toUpperCase() === 'FREE' || !entitled) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default PaidFeatureRoute;
